import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { EntidadProductivaYActividades } from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityEntidadesProductivaActividadAdapter: EntityAdapter<EntidadProductivaYActividades> =
  createEntityAdapter<EntidadProductivaYActividades>({
    selectId: (model) => model.entidad_productiva_id,
    sortComparer: (
      a: EntidadProductivaYActividades,
      b: EntidadProductivaYActividades
    ): number =>
      b.entidad_productiva_id
        .toString()
        .localeCompare(a.entidad_productiva_id.toString())
  });

export interface EntityEntidadesProductivaActividadState
  extends EntityState<EntidadProductivaYActividades> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityEntidadesProductivaActividadState =
  entityEntidadesProductivaActividadAdapter.getInitialState({
    isLoading: false,
    error: null
  });
